import ClickOutside from 'components/Global/ClickOutside';
import React, { useState, useEffect, useRef } from 'react';
import { DayPicker } from 'react-day-picker';

const FILTERS = [
  { label: 'Semua', value: 'all' },
  { label: 'Read', value: 'read' },
  { label: 'Unread', value: 'unread' },
  'divider',
  { label: 'Hari Ini', value: 'today' },
  { label: 'Minggu Ini', value: 'this-week' },
  { label: 'Bulan Ini', value: 'this-month' },
  'divider',
  { label: 'Pilih Tanggal', value: 'custom-date' },
];

const FilterDropdown = ({ filter, setFilter, setRange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('Semua');
  const dropdownRef = useRef(null);

  const [days, setDays] = useState({ from: undefined, to: undefined });
  const [calendarOpen, setCalendarOpen] = useState(false);

  const css = `
  .my-selected:not([disabled]) { 
    font-weight: bold; 
    background-color: black;
    color: white;
  }
  .my-selected:hover([disabled]) { 
    color: currentColor;
    border: 1px solid #000;
  }
`;

  useEffect(() => {
    // Reset internal label when parent resets filter
    if (filter === 'all') {
      setSelected('Semua');
      setDays({ from: undefined, to: undefined });
    }
  }, [filter]);

  const chooseDate = (date) => {
    setDays(date);
    setRange(date);
    setFilter('custom-date');
  };

  // const startDate = format(new Date(days?.from), 'yyyy-MM-dd');

  // console.log('xx', startDate);

  const handleSelect = (item) => {
    if (item === 'divider') return;
    setSelected(item.label);
    setIsOpen(false);
    setFilter(item.value);

    if (item.value === 'custom-date') {
      setCalendarOpen(true);
    }
  };

  // 👇 Detect click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="filter-dropdown" ref={dropdownRef}>
      <button className="filter-dropdown__trigger" onClick={() => setIsOpen(!isOpen)}>
        {/* {selected} <span className="arrow">{isOpen ? '▲' : '▼'}</span> */}
        <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.5 1C0.5 0.734784 0.605357 0.48043 0.792893 0.292893C0.98043 0.105357 1.23478 0 1.5 0H17.5C17.7652 0 18.0196 0.105357 18.2071 0.292893C18.3946 0.48043 18.5 0.734784 18.5 1C18.5 1.26522 18.3946 1.51957 18.2071 1.70711C18.0196 1.89464 17.7652 2 17.5 2H1.5C1.23478 2 0.98043 1.89464 0.792893 1.70711C0.605357 1.51957 0.5 1.26522 0.5 1ZM2.5 5.5C2.5 5.23478 2.60536 4.98043 2.79289 4.79289C2.98043 4.60536 3.23478 4.5 3.5 4.5H15.5C15.7652 4.5 16.0196 4.60536 16.2071 4.79289C16.3946 4.98043 16.5 5.23478 16.5 5.5C16.5 5.76522 16.3946 6.01957 16.2071 6.20711C16.0196 6.39464 15.7652 6.5 15.5 6.5H3.5C3.23478 6.5 2.98043 6.39464 2.79289 6.20711C2.60536 6.01957 2.5 5.76522 2.5 5.5ZM5.5 10C5.5 9.73478 5.60536 9.48043 5.79289 9.29289C5.98043 9.10536 6.23478 9 6.5 9H12.5C12.7652 9 13.0196 9.10536 13.2071 9.29289C13.3946 9.48043 13.5 9.73478 13.5 10C13.5 10.2652 13.3946 10.5196 13.2071 10.7071C13.0196 10.8946 12.7652 11 12.5 11H6.5C6.23478 11 5.98043 10.8946 5.79289 10.7071C5.60536 10.5196 5.5 10.2652 5.5 10Z"
            fill="black"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="filter-dropdown__menu">
          {FILTERS.map((item, idx) =>
            item === 'divider' ? (
              <div key={idx} className="divider" />
            ) : (
              <button
                key={item.value}
                className={`filter-dropdown__item ${selected === item.label ? 'active' : ''}`}
                onClick={() => handleSelect(item)}
              >
                {item.label}
              </button>
            ),
          )}
        </div>
      )}

      {calendarOpen && (
        <ClickOutside onClickOutside={() => setCalendarOpen(false)}>
          <style>{css}</style>
          <DayPicker
            selected={days}
            numberOfMonths={2}
            onSelect={chooseDate}
            mode="range"
            className={`date-dropdown start vertical-bottom }`}
            modifiersClassNames={{
              selected: 'my-selected',
              today: 'my-today',
            }}
            styles={{
              caption_label: { fontSize: '16px' },
              caption: { marginBottom: '33px' },
              head: { color: '#8E8C9A' },
              head_cell: { textTransform: 'capitalize' },
            }}
          />
        </ClickOutside>
      )}
    </div>
  );
};

export default FilterDropdown;
